export const issueTypes = [
  { value: 'boss', label: 'boss 道具未下发', fields: [
    { key: 'occurredDate', label: '发生时间', type: 'date', required: true },
    { key: 'bossMap', label: '击杀 BOSS / 地图', type: 'text' },
  ] },
  { value: 'repeat', label: '重复充值', fields: [
    { key: 'amount', label: '重复充值金额', type: 'amount', required: true },
    { key: 'paymentDate', label: '充值时间', type: 'date', required: true },
    { key: 'orderNo', label: '订单号', type: 'text' },
  ] },
  { value: 'ticket', label: '门票使用异常', fields: [
    { key: 'item', label: '使用道具', type: 'text', required: true },
    { key: 'itemDate', label: '道具使用时间', type: 'date', required: true },
  ] },
  { value: 'report', label: '举报脚本', fields: [
    { key: 'reportedServer', label: '被举报区服', type: 'text' },
    { key: 'reportedRole', label: '被举报角色 ID / 名称', type: 'text', required: true },
  ] },
  { value: 'other', label: '其他', fields: [
    { key: 'description', label: '问题描述', type: 'textarea', required: true, maxlength: 300 },
  ] },
];

export function validateScenario(type, values) {
  const definition = issueTypes.find(item => item.value === type);
  if (!definition) return '请选择客诉类型';
  for (const field of definition.fields) {
    const value = String(values[field.key] == null ? '' : values[field.key]).trim();
    if (field.required && !value) return `请填写${field.label}`;
    if (value.length > (field.maxlength || 128)) return `${field.label}最多 ${field.maxlength || 128} 个字符`;
    if (field.type === 'amount' && (!/^(0|[1-9]\d{0,11})(\.\d{1,2})?$/.test(value) || !/[1-9]/.test(value))) return '请输入大于 0 的金额，整数最多 12 位、最多两位小数';
    if (field.type === 'date' && value) {
      const date = new Date(`${value}T00:00:00Z`);
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || !Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) return `请选择有效的${field.label}`;
    }
  }
  return '';
}
